import { render } from "./LeadsComponent.vue?vue&type=template&id=2e07f23c&scoped=true"
import script from "./LeadsComponent.vue?vue&type=script&lang=js"
export * from "./LeadsComponent.vue?vue&type=script&lang=js"

import "./LeadsComponent.vue?vue&type=style&index=0&id=2e07f23c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e07f23c"]])

export default __exports__